import { db } from "@/firebaseConfig";
const logsCollection = db.collection("logs");

const saveLog = async data => {
  logsCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Log successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateLog = async (id, data) => {
  logsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Log successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteLog = async id => {
  logsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Log successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getLogById = async id => {
  return logsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getLogsByDateRange = async (date1, date2) => {
  return logsCollection
    .where("time", ">=", date1)
    .where("time", "<=", date2)
    .orderBy("time", "desc")
    .get()
    .then(querySnapshot => {
      let result = [];

      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

export {
  logsCollection,
  saveLog,
  updateLog,
  deleteLog,
  getLogById,
  getLogsByDateRange
};
